module.exports = __webpack_public_path__ + "static/img/mooc.46f7ae9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/mooc.jpg
// module id = XRu6
// module chunks = 58